import React from 'react';
import { homeObjOne } from './Data';
import {
  HomeNavbar,
  HomeFooter,
  HomeInfoSection,
  HomePricing,
  HomePorQueKusina,
} from '../../components';

const Home = () => {
  return (
    <>
      <HomeNavbar />
      <HomeInfoSection {...homeObjOne} />
      <HomePorQueKusina />
      <HomePricing />
      {/*<HomeAnfitriones />*/}
      <HomeFooter />
    </>
  )
}

export default Home
